module.exports = __webpack_public_path__ + "static/media/loading-x40.0e7c9d3f.gif";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/loading-x40.gif
// module id = 1142
// module chunks = 0